import { useEffect, useState } from 'react';
import {
	useStripe
} from "@stripe/react-stripe-js";
import addOnPaymentRequestReceived from "./AddOnPaymentRequestReceived";

//Payment request means a google/apple payment request

const usePaymentRequest = (clientSecret, requiresShipping, totalToPay,paymentLabel, onSuccess, showError) => {
	const stripe = useStripe();
	const [paymentRequestId, setPaymentRequestId] = useState(1);
	const [paymentRequest, setPaymentRequest] = useState(null);

	useEffect(() => {
		if (stripe) {
			setNewPaymentRequest(totalToPay, requiresShipping);
		}
	}, [stripe]);


	const setNewPaymentRequest = async (totalToPay, needsShipping, isUpdate = false) => {

		const shippingOptions = needsShipping ? [
			{
				id: 'Standard',
				label: 'Shipping',
				detail: '',
				amount: 0
			}
		] : [];

		const args = {
			requestPayerName: true,
			requestPayerEmail: true,
			requestShipping: needsShipping,
			//disableWallets:['browserCard','googlePay'], //for testing
			disableWallets: ['browserCard'],
			country: 'GB',
			currency: 'gbp',
			shippingOptions,
			total: {
				label: paymentLabel,
				amount: totalToPay * 100,
			}
		};

		const pr = stripe
			.paymentRequest(args);

		const result = await pr.canMakePayment(); //i.e. can use apple/google pay etc
		if (result) {
			addOnPaymentRequestReceived(stripe,clientSecret,pr, onSuccess, showError);
			setPaymentRequest(pr);
			if (isUpdate) {
				setPaymentRequestId(paymentRequestId + 1);
			}
		}
	}


	return {
		paymentRequestId,
		setNewPaymentRequest,
		paymentRequest
	};
}


export default usePaymentRequest;